import { useState } from "react";
import { useTranslation } from "react-i18next";
import { LANGUAGES, changeLanguage } from "@/i18n";
import { Globe, Check } from "lucide-react";

export default function LanguageSwitcher() {
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const current = LANGUAGES.find((l) => l.code === i18n.language) || LANGUAGES[0];

  const pick = (code) => {
    changeLanguage(code);
    setOpen(false);
  };

  return (
    <div className="card-nb p-4 bg-white" data-testid="language-switcher">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between gap-3"
        data-testid="language-toggle"
      >
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#5EEAD4] to-[#14C8B0] flex items-center justify-center shadow-glow shrink-0">
            <Globe className="w-5 h-5 text-white" strokeWidth={2.5}/>
          </div>
          <div className="text-left">
            <div className="text-xs font-display font-bold uppercase tracking-widest text-[#7C828D]">{t("profile.appLanguage")}</div>
            <div className="font-display font-extrabold text-base flex items-center gap-2">
              <span className="text-lg leading-none">{current.flag}</span> {current.label}
            </div>
          </div>
        </div>
        <span className={`text-[#7C828D] transition-transform ${open ? "rotate-180" : ""}`}>▾</span>
      </button>

      {open && (
        <div className="mt-3 pt-3 border-t border-[#E2DFD4] grid grid-cols-1 sm:grid-cols-2 gap-1.5" data-testid="language-options">
          {LANGUAGES.map((l) => {
            const active = l.code === current.code;
            return (
              <button
                key={l.code}
                onClick={() => pick(l.code)}
                data-testid={`lang-${l.code}`}
                className={`flex items-center gap-2 px-3 py-2 rounded-2xl transition-all font-display font-semibold text-sm ${
                  active
                    ? "bg-[#DDF5EA] text-[#0F9D8F]"
                    : "hover:bg-[#F4F2ED] text-[#0A0B0D]"
                }`}
              >
                <span className="text-lg leading-none">{l.flag}</span>
                <span className="flex-1 text-left truncate" dir={l.dir}>{l.label}</span>
                {active && <Check className="w-4 h-4 text-[#14C8B0]" strokeWidth={3}/>}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
